/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {AttachMoneyOutlined, CampaignOutlined, DashboardOutlined, GroupOutlined} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Funnel_Dahsboard from "./Secciones/Seccion_Funnel_Dahsboard";
import Seccion_Depositos from "./Secciones/Seccion_Depositos";
import Seccion_Resultados from "./Secciones/Seccion_Resultados";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {guardarDocs} from "../Servicios/BD/guardarDocs";
import Seccion_Leads from "./Secciones/Seccion_Leads";
import Seccion_Campanas from "./Secciones/Seccion_Campanas";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [open, setOpen] = useState(false)
    const [openTool, setOpenTool] = useState(true);


    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;

    const enviar = async () => {

        let dox = await obtenerCol('leads')

        let arr = []
        for (let i = 0; i < dox.data.length; i++) {

            let obj = dox.data[i]
            obj.estado = 'Nuevo'
            arr.push(obj)
        }

        let doxTodos = await guardarDocs({col: 'leads', arrObj: arr})

    }


    useEffect(() => {

// Oculta el tooltip automáticamente después de 3 segundos
        const timer = setTimeout(() => {
            setOpenTool(false);
        }, 5000);

        // Limpieza del temporizador
        return () => clearTimeout(timer);
    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Provider value={valoresBarra}>
                    <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
                </Provider>
            </Grid>

            {/*} <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 5}}>
                <Tooltip title={'Chatea con nuestro agente de IA'} placement="top-start"
                         open={openTool}
                    // Forzamos a que use la transición Fade
                         TransitionComponent={Fade}
                    // Puedes ajustar la velocidad de la transición aquí (en milisegundos)
                         TransitionProps={{timeout: 1000}}
                >
                    <Box
                        onClick={() => irUrl('https://edu-ai-network.preview.emergentagent.com/')}
                        size={'large'} sx={{
                        background: 'linear-gradient(180deg, #9049F5 0%, #7A1CFF 50%, #39E8FF 100%)',
                        position: 'fixed',
                        bottom: 30,
                        right: 30,
                        pt: 2,
                        pb: 1.5,
                        pl: 2,
                        pr: 1.3,
                        borderRadius: 10,
                        boxShadow: 4,
                        cursor: 'pointer',
                    }}>
                        <img src={chat} width={40} height={'auto'}/>
                    </Box>
                </Tooltip>
            </Grid>*/}

            {/*}  <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', m: 8}}>
                <Button
                    onClick={() => enviar()}
                >Enviar</Button>
            </Grid>
            */}

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 3}}>
                <Typography>Version 0.0.1</Typography>
            </Grid>

        </Grid>
    )

}
export default Dashboard

const secciones = [

    {
        nombre: 'Dashboard',
        icono: DashboardOutlined,
        camino: '*',
        categoria: 'Personal',
        Componente: <Seccion_Funnel_Dahsboard/>
    },
    {
        nombre: 'Leads',
        icono: GroupOutlined,
        camino: '/Leads',
        categoria: 'Personal',
        Componente: <Seccion_Leads/>
    },
    {
        nombre: 'Depositos',
        icono: AttachMoneyOutlined,
        camino: '/Depositos',
        categoria: 'Personal',
        Componente: <Seccion_Depositos/>
    },
    {
        nombre: 'Campañas',
        icono: CampaignOutlined,
        camino: '/Campanas',
        categoria: 'Personal',
        Componente: <Seccion_Campanas/>
    },
]

const seccionesID = [
    {
        nombre: 'Resultados',
        camino: '/Resultados/:id/:idFunnel',
        Componente: <Seccion_Resultados/>
    }


]

const seccionesPerfil = []

const notificaciones = {}